import React, { Component } from 'react'
import { Card, CardHeader, CardBody , Container, Row, Col, CardGroup } from 'reactstrap'
import welcome from '../../images/mp-online-beta-welcome-image.svg' 
import { InvitesMessageBar, InvitesForm } from './'


/*
  <Invites 
    isFetchingInvitation={this.props.isFetchingInvitation}
    isFetchingInvitationError={this.props.isFetchingInvitationError}
    invitation={this.props.invitation}
    saving={this.props.saving}
    savingSuccess={this.props.savingSuccess}
    savingError={this.props.savingError}
    isSaving={this.props.isSaving}
    isSavingError={this.props.isSavingError}
    isStudent={this.props.isStudent}
    isFetchingIsStudent={this.props.isFetchingIsStudent}
    isFetchingIsStudentError={this.props.isFetchingIsStudentError}
  />
*/

class Invites extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
     <Container>
      <Row className="justify-content-center">
       <Col md="8">
        <CardGroup className="mb-0" style= {{"height" : "auto"}}  >
         <Card className="text-white col-sm-5  py-5 d-md-down-none" style={{ 'backgroundColor': '#194250','borderTopRightRadius': '0', 'borderBottomRightRadius': '0' }}>
          <CardBody className="card-body text-center">
            <div style= {{"marginTop": " 85px"}}>
              <p><img src={welcome} alt="MasteryPrep Logo" /></p>
            </div>
            </CardBody>
          </Card>
      <Card className="p-4 " style={{ 'borderTopLeftRadius': '0', 'borderBottomLeftRadius': '0' }}>
      <div className='invite-password-header'>
            <h5>Registration</h5>
          </div>
        <CardBody>
          <InvitesMessageBar
            isFetchingInvitation={this.props.isFetchingInvitation}
            isFetchingInvitationError={this.props.isFetchingInvitationError}
            isSavingError={this.props.isSavingError}
            invitation={this.props.invitation}
            isStudent={this.props.isStudent}
          />
          <InvitesForm
            isFetchingInvitationError={this.props.isFetchingInvitationError}
            invitation={this.props.invitation}
            saving={this.props.saving}
            savingSuccess={this.props.savingSuccess}
            savingError={this.props.savingError}
            isSaving={this.props.isSaving}
            isStudent={this.props.isStudent}
            isFetchingIsStudent={this.props.isFetchingIsStudent}
            isFetchingIsStudentError={this.props.isFetchingIsStudentError}
            history={this.props.history}
          />
        </CardBody>
         </Card>
         </CardGroup>
        </Col>
       </Row>
      </Container>
      </div>
    )
  }
}

export default Invites


// WEBPACK FOOTER //
// ./src/components/Users/Invites.js